import { Theme } from '@mui/material';

export default {
	styleOverrides: {
		root: ({ theme }: { theme: Theme }) => ({
			borderRadius: '8px',
			'&.Mui-selected': {
				backgroundColor: theme.palette.primary.main,
				color: theme.palette.primary.contrastText,
				'&:hover': {
					backgroundColor: theme.palette.primary.main,
				},
				'&:focus': {
					backgroundColor: theme.palette.primary.main,
				},
			},
		}),
	},
};
